import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43e48d1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "top-menu collapse navbar-collapse px-5",
  id: "navbarSupportedContent"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 text-danger",
  style: {"background-color":"white"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ni ni-user-run" }),
  /*#__PURE__*/_createTextVNode("   "),
  /*#__PURE__*/_createElementVNode("span", { style: {"cursor":"pointer"} }, "Logout")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fas fa-angle-double-right pull-right",
  style: {"float":"inline-end","padding-top":"4px"}
}, null, -1))
const _hoisted_6 = { class: "navbar-nav align-items-center ml-md-auto" }
const _hoisted_7 = { class: "nav-item is-web d-xl-none" }
const _hoisted_8 = {
  class: "pr-3 sidenav-toggler sidenav-toggler-dark",
  "data-action": "sidenav-pin",
  "data-target": "#sidenav-main"
}
const _hoisted_9 = { class: "nav-item is-mobile" }
const _hoisted_10 = { class: "nav-link text-white" }
const _hoisted_11 = { class: "text-white" }
const _hoisted_12 = { class: "navbar-nav align-items-center ml-auto ml-md-0" }
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = {
  class: "nav-link pr-0",
  href: "#",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_15 = { class: "media align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-crosshairs mr-4 text-white" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle text-white" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "is-web avatar avatar-sm rounded-circle",
  style: {"font-size":"xx-large"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle" })
], -1))
const _hoisted_21 = { class: "media-body ml-2 d-none d-md-block" }
const _hoisted_22 = { class: "mb-0 text-sm font-weight-bold" }
const _hoisted_23 = { class: "is-web dropdown-menu dropdown-menu-right" }
const _hoisted_24 = { class: "dropdown-header noti-title" }
const _hoisted_25 = { class: "text-overflow m-0" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ni ni-user-run" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"cursor":"pointer"} }, "Logout", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_drawer_content = _resolveComponent("n-drawer-content")!
  const _component_n_drawer = _resolveComponent("n-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_drawer, {
      show: _ctx.isShow,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShow) = $event)),
      placement: "bottom",
      height: "15%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_drawer_content, {
          "header-style": "display: block !important;",
          "footer-style": "display: block !important;"
        }, {
          header: _withCtx(() => [
            _createTextVNode(" Hi " + _toDisplayString(_ctx.username) + "! ", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_n_space, { vertical: "" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "row",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                }, _hoisted_3)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    (_ctx.showSite)
      ? (_openBlock(), _createElementBlock("form", {
          id: "navbar-search-main",
          class: "navbar-search navbar-search-light form-inline mr-sm-3 w-50 is-web",
          key: _ctx.options
        }, [
          (_ctx.options)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 0,
                name: "custom-classes-transition",
                "enter-active-class": "animate__animated animate__fadeIn animate__faster",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "site-selection",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goAuthSite()))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.options.name) + " ", 1),
                      _hoisted_5
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_6, [
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("i", {
            class: "fas fa-bars text-white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu()))
          })
        ])
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("a", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(!_ctx.showSite ? "Nexus Point" : _ctx.options?.name), 1)
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_12, [
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("a", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.showSite)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "is-mobile rounded-circle",
                  style: {"font-size":"x-large"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goAuthSite()))
                }, _hoisted_17))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "is-mobile rounded-circle",
              style: {"font-size":"x-large"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleActionSheet()))
            }, _hoisted_19),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.username), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h6", _hoisted_25, "Hi " + _toDisplayString(_ctx.username) + " !", 1)
          ]),
          _createElementVNode("div", {
            class: "dropdown-item",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.logout()))
          }, _hoisted_28)
        ])
      ])
    ])
  ]))
}